import type { HajocaAccountResponse } from "@onsemble/shared/types/hajoca";
import { TanstackError } from "../client";

/**
 * Lookup a Hajoca customer by ID to get contact info (phone, address)
 */
export async function lookupHajocaCustomer(
  customerId: string
): Promise<HajocaAccountResponse> {
  const response = await fetch(`/api/hajoca/customers/${encodeURIComponent(customerId)}`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    throw new TanstackError(
      response.status,
      "Failed to lookup Hajoca customer"
    );
  }

  return response.json();
}
